import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import Countdown from "react-countdown";
import { CaseActionEventTypeEnum } from "../../../api/dataModel";
import { useStore } from "../../../Store";

const ETAcomponent = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();
  const event = casesStore.latestEvent;
  if (!event) return null;

  if (event.eventType >= CaseActionEventTypeEnum.ArrivalAtIncidentSite &&
      event.eventType <= CaseActionEventTypeEnum.ServiceExecuted) {
    return <div>{t("ETAtextCountdownCompleted")}</div>;
  }
  if (event.etaMinutes < 0) return <div>{t("ETAtext", { eta: 0 })}</div>;
  if (event.etaMinutes === 0) return null;

  const arrival = new Date(event.eventDateTime).getTime() + event.etaMinutes * 60000;
  if (!Number.isFinite(arrival)) return null;

  return <Countdown date={arrival} intervalDelay={30000}
    renderer={({ total, completed }) => {
      if (completed) return <div>{t("ETAtextCountdownCompleted")}</div>;
      const roundedMinutes = Math.ceil(total / 60000);
      const hours = Math.floor(roundedMinutes / 60);
      const minutes = roundedMinutes % 60;
      return <div>{hours > 0
        ? t("ETAtextH", { etah: hours, eta: minutes })
        : t("ETAtext", { eta: minutes })}</div>;
    }} />;
};

export default observer(ETAcomponent);
